// tslint:disable
export var ProgramUsageType;
(function (ProgramUsageType) {
    // Hub
    ProgramUsageType[ProgramUsageType["Hub"] = 1] = "Hub";
    // Copay
    ProgramUsageType[ProgramUsageType["Copay"] = 2] = "Copay";
    // Pap
    ProgramUsageType[ProgramUsageType["PatientAssitanceProgram"] = 3] = "PatientAssitanceProgram";
})(ProgramUsageType || (ProgramUsageType = {}));
ProgramUsageType['HUB'] = 1;
ProgramUsageType['COPAY'] = 2;
ProgramUsageType['PATIENTASSITANCEPROGRAM'] = 3;
//# sourceMappingURL=ProgramUsageType.js.map